<template>
<div>
  11

</div>
</template>

<script>

export default {
  name: 'demo',

  methods: {
    load() {
      
    }
  },
  mounted() {
    this.load()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/demo/index.vue